import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const inDemo = () =>
  typeof window !== "undefined" && window.location.pathname.startsWith("/demo");

const isMutation = (m) => ["post", "put", "patch", "delete"].includes((m || "get").toLowerCase());

function emitDemoLocked() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent("demo-locked"));
}

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const startingDemo = url.includes("demo/start");
  if (inDemo()) {
    const token = sessionStorage.getItem("pmw_demo");
    if (token && !startingDemo) config.headers.Authorization = `Bearer ${token}`;
    // Block any write from demo mode client-side (defense-in-depth; server also rejects).
    if (isMutation(config.method) && !startingDemo) {
      emitDemoLocked();
      return Promise.reject({ __demo_locked: true });
    }
  } else {
    const token = localStorage.getItem("pmw_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err && err.__demo_locked) return Promise.reject(err);
    if (err?.response?.status === 403 && err?.response?.data?.code === "demo_readonly") emitDemoLocked();
    return Promise.reject(err);
  }
);

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errText = apiErr;

export default api;
